var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBvsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#50D24A",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "#50D24A",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 36.0247L33.6824 40.7021C35.9344 36.7642 39.0511 33.3889 42.7974 30.8307L43 30.6924M54.2999 35C54.2999 45.1068 46.1068 53.2999 36 53.2999C25.8931 53.2999 17.7 45.1068 17.7 35C17.7 24.8931 25.8931 16.7 36 16.7C46.1068 16.7 54.2999 24.8931 54.2999 35Z",
    stroke: "#F2F3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvsuccess);
export default __webpack_public_path__ + "static/media/bvsuccess.375d324b49013af1bf5a311506c9004d.svg";
export { ForwardRef as ReactComponent };